module.exports = "pegasus_template/assets/blocks/header-2-tech.png";